import { useEffect, useState } from "react";
import { generateRandomString } from "../../utils/helper";
import Checkbox from "@mui/material/Checkbox";
import { getAccessControls } from "../../apis/System/accessControl.api";

const PermissionIndex = {
  READ: 1,
  CREATE: 2,
  UPDATE: 3,
  DELETE: 4,
};

const AccessControlTableHead = [
  "Access Control",
  "Read",
  "Create",
  "Update",
  "Delete",
];

const renderHead = (item, index, handleClickAll, checkedType) => (
  <th key={index}>
    <p>{item}</p>
    {index !== 0 ? (
      <Checkbox
        checked={checkedType.includes(index)}
        label=""
        onClick={() => handleClickAll(index)}
      />
    ) : null}
  </th>
);

const handleShowCheckedType = (
  fullReadPerIds,
  fullCreatePerIds,
  fullUpdatePerIds,
  fullDeletePerIds,
  checkedPerIds
) => {
  // handle check all
  let allRead = fullReadPerIds.every((ai) => {
    return checkedPerIds.includes(ai);
  })
    ? PermissionIndex.READ
    : 0;
  let allCreate = fullCreatePerIds.every((ai) => checkedPerIds.includes(ai))
    ? PermissionIndex.CREATE
    : 0;
  let allUpdate = fullUpdatePerIds.every((ai) => checkedPerIds.includes(ai))
    ? PermissionIndex.UPDATE
    : 0;
  let allDelete = fullDeletePerIds.every((ai) => checkedPerIds.includes(ai))
    ? PermissionIndex.DELETE
    : 0;

  return [allRead, allCreate, allUpdate, allDelete];
};

const GridSelectPermission = (props) => {
  const { checked, setChecked, listPermissionOfRole } = props;

  const [listAccessControl, setListAccessControl] = useState([]);
  const [checkedType, setCheckedType] = useState([]);
  const [checkedAllRead, setCheckedAllRead] = useState([]);
  const [checkedAllCreate, setCheckedAllCreate] = useState([]);
  const [checkedAllUpdate, setCheckedAllUpdate] = useState([]);
  const [checkedAllDelete, setCheckedAllDelete] = useState([]);

  useEffect(() => {
    getAccessControls((result) => {
      setListAccessControl([...listAccessControl, ...result]);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // reset lại checked check all khi submit form
  useEffect(() => {
    if (!checked.length) {
      setCheckedType([]);
    }
  }, [checked]);

  useEffect(() => {
    let listPermissionReadId = [];
    let listPermissionCreateId = [];
    let listPermissionUpdateId = [];
    let listPermissionDeleteId = [];
    for (const accessControl of listAccessControl) {
      accessControl.permissions.sort((permission, prevPermission) => {
        return permission.index - prevPermission.index;
      });

      for (const permission of accessControl.permissions) {
        if (permission.index === PermissionIndex.READ) {
          listPermissionReadId.push(permission.id);
        }
        if (permission.index === PermissionIndex.CREATE) {
          listPermissionCreateId.push(permission.id);
        }
        if (permission.index === PermissionIndex.UPDATE) {
          listPermissionUpdateId.push(permission.id);
        }
        if (permission.index === PermissionIndex.DELETE) {
          listPermissionDeleteId.push(permission.id);
        }
      }
    }

    // * kiểm tra xem permission (read, create, update, delete) đang được chọn hết THÌ gán checkedType cho permission đó
    const updateListCheckedType = handleShowCheckedType(
      listPermissionReadId,
      listPermissionCreateId,
      listPermissionUpdateId,
      listPermissionDeleteId,
      checked
    );

    setCheckedType(updateListCheckedType);
    setCheckedAllRead([...checkedAllRead, ...listPermissionReadId]);
    setCheckedAllCreate([...checkedAllCreate, ...listPermissionCreateId]);
    setCheckedAllUpdate([...checkedAllUpdate, ...listPermissionUpdateId]);
    setCheckedAllDelete([...checkedAllDelete, ...listPermissionDeleteId]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listAccessControl]);

  const handleCheck = (event) => {
    var updatedList = [...checked];
    if (event.target.checked) {
      updatedList = [...checked, event.target.value];
    } else {
      updatedList.splice(checked.indexOf(event.target.value), 1);
    }
    // * kiểm tra xem permission (read, create, update, delete) đang được chọn hết THÌ gán checkedType cho permission đó
    const updateListCheckedType = handleShowCheckedType(
      checkedAllRead,
      checkedAllCreate,
      checkedAllUpdate,
      checkedAllDelete,
      updatedList
    );

    setChecked(updatedList);
    setCheckedType(updateListCheckedType);
  };

  const handleClickAll = (index) => {
    if (index === PermissionIndex.READ && !checkedType.includes(index)) {
      setChecked([...new Set([...checked, ...checkedAllRead])]);
    } else if (index === PermissionIndex.READ && checkedType.includes(index)) {
      const arrayFilter = checked.filter(
        (val) => !checkedAllRead.includes(val)
      );
      setChecked([...arrayFilter]);
    }
    if (index === PermissionIndex.CREATE && !checkedType.includes(index)) {
      setChecked([...new Set([...checked, ...checkedAllCreate])]);
    } else if (
      index === PermissionIndex.CREATE &&
      checkedType.includes(index)
    ) {
      const arrayFilter = checked.filter(
        (val) => !checkedAllCreate.includes(val)
      );
      setChecked([...arrayFilter]);
    }
    if (index === PermissionIndex.UPDATE && !checkedType.includes(index)) {
      setChecked([...new Set([...checked, ...checkedAllUpdate])]);
    } else if (
      index === PermissionIndex.UPDATE &&
      checkedType.includes(index)
    ) {
      const arrayFilter = checked.filter(
        (val) => !checkedAllUpdate.includes(val)
      );
      setChecked([...arrayFilter]);
    }
    if (index === PermissionIndex.DELETE && !checkedType.includes(index)) {
      setChecked([...new Set([...checked, ...checkedAllDelete])]);
    } else if (
      index === PermissionIndex.DELETE &&
      checkedType.includes(index)
    ) {
      const arrayFilter = checked.filter(
        (val) => !checkedAllDelete.includes(val)
      );
      setChecked([...arrayFilter]);
    }

    var updatedList = [...checkedType];
    if (!checkedType.includes(index)) {
      updatedList = [...checkedType, index];
    } else {
      updatedList.splice(checkedType.indexOf(index), 1);
    }
    setCheckedType(updatedList);
  };

  const isChecked = (permissionId) => {
    if (listPermissionOfRole && listPermissionOfRole.length) {
      return (
        checked.includes(permissionId) ||
        listPermissionOfRole.includes(permissionId)
      );
    }
    return checked.includes(permissionId);
  };
  const isDisable = (permissionId) => {
    if (listPermissionOfRole && listPermissionOfRole.length) {
      return listPermissionOfRole.includes(permissionId);
    }
    return false;
  };

  return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <div className="card__body">
            <div className="table-wrapper">
              <table>
                {AccessControlTableHead && renderHead ? (
                  <thead>
                    <tr>
                      {AccessControlTableHead.map((item, index) =>
                        renderHead(item, index, handleClickAll, checkedType)
                      )}
                    </tr>
                  </thead>
                ) : null}
                <tbody>
                  {listAccessControl.map((accessControl, index) => {
                    let list = [
                      <td key={generateRandomString(10)}>{null}</td>,
                      <td key={generateRandomString(10)}>{null}</td>,
                      <td key={generateRandomString(10)}>{null}</td>,
                      <td key={generateRandomString(10)}>{null}</td>,
                    ];
                    const permissions = accessControl.permissions;
                    for (
                      let i = 0;
                      i < Object.keys(PermissionIndex).length;
                      i++
                    ) {
                      if (permissions[i]?.index === 1) {
                        list[0] = (
                          <td key={generateRandomString(10)}>
                            <Checkbox
                              label=""
                              value={permissions[i]?.id}
                              onChange={handleCheck}
                              checked={isChecked(permissions[i]?.id)}
                              disabled={isDisable(permissions[i]?.id)}
                            />
                          </td>
                        );
                      }
                      if (permissions[i]?.index === 2) {
                        list[1] = (
                          <td key={generateRandomString(10)}>
                            <Checkbox
                              label=""
                              value={permissions[i]?.id}
                              onChange={handleCheck}
                              checked={isChecked(permissions[i]?.id)}
                              disabled={isDisable(permissions[i]?.id)}
                            />
                          </td>
                        );
                      }
                      if (permissions[i]?.index === 3) {
                        list[2] = (
                          <td key={generateRandomString(10)}>
                            <Checkbox
                              checked={isChecked(permissions[i]?.id)}
                              disabled={isDisable(permissions[i]?.id)}
                              label=""
                              value={permissions[i]?.id}
                              onChange={handleCheck}
                            />
                          </td>
                        );
                      }
                      if (permissions[i]?.index === 4) {
                        list[3] = (
                          <td key={generateRandomString(10)}>
                            <Checkbox
                              checked={isChecked(permissions[i]?.id)}
                              disabled={isDisable(permissions[i]?.id)}
                              label=""
                              value={permissions[i]?.id}
                              onChange={handleCheck}
                            />
                          </td>
                        );
                      }
                    }
                    return (
                      <tr key={index}>
                        <td>{`${accessControl.name}`}</td>
                        {list}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GridSelectPermission;
